import { User } from 'types/graphql';

const getFullName = (user?: Pick<User, 'firstName' | 'lastName'>): string => {
  if (!user) {
    return '--';
  }

  const { firstName = '', lastName = '' } = user;

  if (!firstName && !lastName) {
    return '--';
  }

  if (!lastName) {
    if (firstName) {
      return firstName;
    }

    return '--';
  }

  return `${firstName} ${lastName}`;
};

export default getFullName;
